import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

const isDev = process.env.NODE_ENV !== "production";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [rank, setRank] = useState("");
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setRank(data.rank);
    } catch (_e) {
      setUser(null);
      setRank("");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    await refresh();
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setUser(data.user);
    await refresh();
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      if (isDev) console.error("Logout request failed:", err);
    }
    setUser(null);
    setRank("");
  };

  return (
    <AuthContext.Provider value={{ user, rank, loading, login, register, logout, refresh, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
